<template>
    <div id="support">
        <top :title="title"></top>
        <div class="content">
            <h3>社区出入通</h3>
            <p>技术支持热线：010-64777377</p>
            <p>技术支持微信：</p>
            <div class="code">
                <img src="@/assets/imgs/ccode.jpg" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import Top from "@/component/top/top";
export default {
    components:{
        Top
    },
    data() {
        return {
            title:'技术支持'
        }
    },
    destroyed() {
        localStorage.setItem("pass",'')
    },
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    #support{
        width: 100%;
        height: 100%;
        background:#24cf8d;
        .content{
            padding:160px 60px 0;
            color:#fff;
            h3{
                font-size:26px;
                margin:0 0 10px 0;
            }
            p{
                margin:0 0 5px 0;
                font-size:18px;
            }
            .code{
                text-align: center;
                margin:25px 0 0 0;
                img{
                    width:50%;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/support/support.vue